export default __webpack_public_path__ + "static/idea2-9d2ba82776e38e24a695924f2955fd5c.jpg";